import React from "react";

const TermsOfUse = () => {
  return (
    <div className="legal">
      <h2>Uvjeti korištenja</h2>
      <h6>Posljednja izmjena: Siječanj 2025.</h6>

      <div className="legal-list">
        <div className="legal-text">
          <h3>
            <div className="legal-number">1.</div> Uvod
          </h3>
          <p>
            Ovi Uvjeti korištenja ("Uvjeti") predstavljaju pravni sporazum
            između vas (korisnika) i našeg web mjesta ("mi", "nas", "naš").
            Korištenjem naših usluga pristajete na ove Uvjete. Ako se ne slažete
            s uvjetima, molimo vas da ne koristite naše usluge.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">2.</div> Korištenje naših usluga
          </h3>
          <p>
            Naše usluge smiju koristiti samo osobe koje su u skladu s važećim
            zakonodavstvom. Korisnici se slažu da neće koristiti usluge u
            nezakonite svrhe.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">3.</div> Registracija i računi
          </h3>
          <p>
            Za korištenje određenih usluga na našem web mjestu, možda ćete
            morati otvoriti korisnički račun. Korisnici su odgovorni za
            održavanje povjerljivosti svojih prijavljivačkih podataka.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">4.</div> Ograničenja odgovornosti
          </h3>
          <p>
            Ne odgovaramo za bilo kakvu štetu, gubitak podataka, ili neuspjeh u
            korištenju naših usluga, bilo izravno ili neizravno.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">5.</div> Prava intelektualnog
            vlasništva
          </h3>
          <p>
            Svi sadržaji na našem web mjestu, uključujući, ali ne ograničavajući
            se na tekstove, slike, dizajn, logotipe, videozapise i ostale
            materijale, zaštićeni su pravima intelektualnog vlasništva i ne
            smiju se koristiti bez prethodnog odobrenja.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">6.</div> Zabrana zloupotrebe
          </h3>
          <p>
            Zabranjeno je korištenje naših usluga u bilo koje nezakonite svrhe,
            uključujući, ali ne ograničavajući se na, distribuciju zlonamjernih
            softverskih programa ili napade na naš sustav.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">7.</div> Izmjene i raskid
          </h3>
          <p>
            Zadržavamo pravo izmjene, ažuriranja ili prekida naših usluga u bilo
            kojem trenutku. U slučaju raskida, vaša prava i obveze nastavit će
            biti obavezna i nakon završetka korištenja naših usluga.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">8.</div> Održavanje privatnosti
          </h3>
          <p>
            Vaša privatnost je važna za nas. Korištenje vaših podataka
            regulirano je našom Politikom privatnosti, koja je sastavni dio ovih
            Uvjeta.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">9.</div> Kontaktirajte nas
          </h3>
          <p>
            Ako imate bilo kakvih pitanja u vezi s našim Uvjetima korištenja ili
            našim uslugama, slobodno nas kontaktirajte putem e-maila na:{" "}
            <a href="/">contact@yourwebsite.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
